import { createFeatureSelector, createSelector, Store, StoreModule } from '@ngrx/store';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { __decorate, __param } from 'tslib';
import { InjectionToken, Injectable, Inject, NgModule } from '@angular/core';
import { ofType, Actions, Effect, EffectsModule } from '@ngrx/effects';
import { filter, map, shareReplay, take, switchMap, retry, withLatestFrom, catchError, mergeMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngrx/store';
import * as ɵngcc2 from '@angular/common/http';
import * as ɵngcc3 from 'rxjs';
import * as ɵngcc4 from '@ngrx/effects';
var GlobalToggleActions;
(function (GlobalToggleActions) {
    GlobalToggleActions["GetGlobalToggleAction"] = "[Global Toggles] Get Toggle";
    GlobalToggleActions["OverrideGlobalToggle"] = "[Global Toggles] Set Toggle";
    GlobalToggleActions["GlobalToggleCacheHit"] = "[Global Toggles] Cache Hit";
    GlobalToggleActions["GlobalToggleCacheMiss"] = "[Global Toggles] Cache Miss";
    GlobalToggleActions["UpsertGlobalToggleCache"] = "[Global Toggles] Upsert Cache";
    GlobalToggleActions["BulkUpsertGlobalToggleCache"] = "[Global Toggles] Bulk Upsert Cache";
    GlobalToggleActions["GlobalToggleUnknown"] = "[Global Toggles] Unknown Toggle";
    GlobalToggleActions["GetAllGlobalTogglesAction"] = "[Global Toggles] Get All Toggles";
    GlobalToggleActions["GetAllGlobalTogglesError"] = "[Global Toggles] Get All Toggles Fail";
})(GlobalToggleActions || (GlobalToggleActions = {}));
/**
 * @platformUseOnly
 * @description
 * This action will ensure **all** scout toggles have been fetched
 * and the result is present in the store.
 * @example
 * this.store.dispatch(new GetAllGlobalTogglesAction());
 */
class GetAllGlobalTogglesAction {
    constructor() {
        this.type = GlobalToggleActions.GetAllGlobalTogglesAction;
    }
}
/**
 * @publicApi
 * @description
 * This action will ensure a single scout toggle has been fetched
 * and the result is present in the store.
 * @usageNotes
 * This can be called just before a toggle selector is used so that
 * the toggle fetch will be made (if it hasn't already).
 * @example
 * this.store.dispatch(new GetAllGlobalTogglesAction({owner: 'olshell', name: 'foo'}));
 */
class GetGlobalToggleAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GlobalToggleActions.GetGlobalToggleAction;
    }
}
class GetAllGlobalTogglesError {
    constructor(payload) {
        this.payload = payload;
        this.type = GlobalToggleActions.GetAllGlobalTogglesError;
    }
}
class OverrideGlobalToggle {
    constructor(payload) {
        this.payload = payload;
        this.type = GlobalToggleActions.OverrideGlobalToggle;
    }
}
class UpsertGlobalToggleCache {
    constructor(payload) {
        this.payload = payload;
        this.type = GlobalToggleActions.UpsertGlobalToggleCache;
    }
}
class BulkUpsertGlobalToggleCache {
    constructor(payload) {
        this.payload = payload;
        this.type = GlobalToggleActions.BulkUpsertGlobalToggleCache;
    }
}
class GlobalToggleCacheHit {
    constructor(payload) {
        this.payload = payload;
        this.type = GlobalToggleActions.GlobalToggleCacheHit;
    }
}
class GlobalToggleCacheMiss {
    constructor(payload) {
        this.payload = payload;
        this.type = GlobalToggleActions.GlobalToggleCacheMiss;
    }
}
class GlobalToggleUnknown {
    constructor(payload) {
        this.payload = payload;
        this.type = GlobalToggleActions.GlobalToggleUnknown;
    }
}

const sliceName = 'globalToggles';
const initialState = { toggles: {}, allLoaded: false };
function toggleReducer(state = initialState, action) {
    switch (action.type) {
        case GlobalToggleActions.UpsertGlobalToggleCache: {
            const { identifier, value } = action.payload;
            const newState = upsertToggle(Object.assign({}, state), { identifier, value });
            return Object.assign({}, newState);
        }
        case GlobalToggleActions.OverrideGlobalToggle: {
            /*
             *  This behaves differently than the upsert override.
             */
            const override = action.payload;
            const identifier = { owner: override.owner, name: override.name };
            const value = { value: override, isOverridden: true, error: null };
            let newToggle;
            const hasExistingToggle = state.toggles[identifier.owner] && state.toggles[identifier.owner][identifier.name] !== undefined;
            const existingToggle = hasExistingToggle ? state.toggles[identifier.owner][identifier.name] : undefined;
            if (existingToggle && existingToggle.isOverridden) {
                // only update the properties specified
                const existingScoutToggle = existingToggle.value;
                const mergedScoutToggle = Object.assign(Object.assign({}, existingScoutToggle), override);
                newToggle = Object.assign(Object.assign({}, existingToggle), { value: mergedScoutToggle });
            }
            else {
                newToggle = { value: override, isOverridden: true, error: null };
            }
            const newState = Object.assign(Object.assign({}, state), { toggles: Object.assign(Object.assign({}, state.toggles), { [identifier.owner]: Object.assign(Object.assign({}, state.toggles[identifier.owner]), { [identifier.name]: newToggle }) }) });
            return Object.assign({}, newState);
        }
        case GlobalToggleActions.BulkUpsertGlobalToggleCache: {
            let newState = Object.assign({}, state);
            const toggles = action.payload;
            toggles.forEach((scoutToggle) => {
                const toggle = { value: scoutToggle, error: null, isOverridden: false };
                const identifier = { owner: scoutToggle.owner, name: scoutToggle.name };
                newState = upsertToggle(Object.assign({}, newState), { identifier, value: toggle });
            });
            return Object.assign(Object.assign({}, newState), { allLoaded: true });
        }
        case GlobalToggleActions.GetAllGlobalTogglesError: {
            const newState = Object.assign({}, state);
            const error = action.payload;
            newState.allLoaded = error;
            return newState;
        }
        default: {
            return state;
        }
    }
}
function upsertToggle(state, { identifier, value }) {
    let newToggle;
    const hasExistingToggle = state.toggles[identifier.owner] && state.toggles[identifier.owner][identifier.name] !== undefined;
    const existingToggle = hasExistingToggle ? state.toggles[identifier.owner][identifier.name] : undefined;
    if (existingToggle && existingToggle.isOverridden) {
        // keep the overridden ScoutToggle value "sticky"
        const existingScoutToggle = existingToggle.value;
        const newScoutToggle = value.value;
        const mergedScoutToggle = Object.assign(Object.assign({}, newScoutToggle), { value: existingScoutToggle.value });
        newToggle = Object.assign(Object.assign({}, existingToggle), { value: mergedScoutToggle });
        console.log('newToggle ', JSON.stringify(Object.assign({}, newToggle)));
    }
    else {
        newToggle = value;
    }
    const newState = Object.assign(Object.assign({}, state), { toggles: Object.assign(Object.assign({}, state.toggles), { [identifier.owner]: Object.assign(Object.assign({}, state.toggles[identifier.owner]), { [identifier.name]: newToggle }) }) });
    return Object.assign({}, newState);
}

const getAllGlobalToggles = createFeatureSelector(sliceName);
/**
 * @publicApi
 * @description
 * Emits a toggle from the store, or null if the toggle doesn't exist.
 * @throws an (http) error if the toggle fetch failed
 * @example
 * this.store.pipe(
 *  select(getGlobalToggleSelector({owner: 'olshell', name: 'foo'})),
 *  tap((toggle) => console.log('got toggle!', value)),
 *  catchError((err) => console.error('toggle fetch failed', err))
 * );
 */
function getGlobalToggleSelector({ owner, name, }) {
    return createSelector(getAllGlobalToggles, (togglesSlice) => {
        const toggle = togglesSlice.toggles[owner] && togglesSlice.toggles[owner][name];
        const errorOnToggle = toggle && toggle.error;
        const errorOnAllToggles = togglesSlice.allLoaded instanceof HttpErrorResponse ? togglesSlice.allLoaded : undefined;
        const error = errorOnToggle || errorOnAllToggles;
        if (error) {
            throw error;
        }
        else if (!toggle) {
            return null;
        }
        else {
            return toggle.value;
        }
    });
}
const ɵ0 = (togglesSlice) => {
    if (togglesSlice.allLoaded instanceof HttpErrorResponse) {
        throw togglesSlice.allLoaded;
    }
    return togglesSlice.allLoaded;
};
/**
 * @platformUseOnly
 * @description
 * Emits true when the fetch for all toggle succeeds.
 * @throws an (http) error if the toggle fetch failed
 * @example
 * this.store.pipe(
 *  select(getGlobalTogglesLoaded),
 *  tap((areTogglesLoaded) => console.log('update to toggles loaded!', areTogglesLoaded)),
 *  catchError((err) => console.error('all toggle fetch failed', err))
 * );
 */
const getAllGlobalTogglesLoaded = createSelector(getAllGlobalToggles, ɵ0);

const defaultHostNames = {
    dev: {
        scoutProxy: 'toggles-dev.redbird.nonprod.mheducation.com',
    },
    qastg: {
        scoutProxy: 'toggles-qastg.redbird.nonprod.mheducation.com',
    },
    qalv: {
        scoutProxy: 'toggles-qalv.redbird.nonprod.mheducation.com',
    },
    demo: {
        scoutProxy: 'toggles-demo.redbird.nonprod.mheducation.com',
    },
    pqa: {
        scoutProxy: 'toggles-pqa.redbird.nonprod.mheducation.com',
    },
    prod: {
        scoutProxy: 'toggles-prod.redbird.prod.mheducation.com',
    },
};

const GLOBAL_TOGGLE_CONFIG = new InjectionToken('GLOBAL_TOGGLE_CONFIG');
function hostnamesFromConfig(config) {
    if (config.hostNames !== undefined) {
        return config.hostNames;
    }
    else if (config.sdlcEnvironment !== undefined) {
        if (defaultHostNames[config.sdlcEnvironment] === undefined) {
            throw new Error(`GlobalTogglesModule config is invalid: config.sdlcEnvironment=${config.sdlcEnvironment} is an unknown SDLC`);
        }
        return defaultHostNames[config.sdlcEnvironment];
    }
    else {
        throw new Error('GlobalTogglesModule config is invalid: must define either sdlcEnvironment or larsHostname');
    }
}

const requiredToggleValues = [
    {
        name: 'name',
        type: 'string',
    },
    {
        name: 'owner',
        type: 'string',
    },
    {
        name: 'value',
        type: 'boolean',
    },
];
/**
 * A service that places a function on the window so that toggles can be overridden.
 * @example
 * window.overrideGlobalToggle({owner: 'olshell', name: 'foo', value: false});
 * @todo
 * Remove this when we have a UI to toggle things.
 * This is just so QA can start writing Selenium tests.
 */
let TemporaryWindowOverrideTogglesService = class TemporaryWindowOverrideTogglesService {
    constructor(store) {
        this.store = store;
        if (window) {
            const methodName = 'overrideGlobalToggle';
            window[methodName] = (toggle) => {
                // error checking, just to be nice
                if (toggle === null || typeof toggle !== 'object') {
                    throw new Error(`${methodName}: input arugment must be an object with properties {name, owner, value}`);
                }
                // check the values that were provided
                Object.keys(toggle).forEach((key) => {
                    const allowedProperty = requiredToggleValues.find(({ name }) => name === key);
                    if (!allowedProperty) {
                        throw new Error(`${methodName}: toggle override property "${key}" is not allowed to be set`);
                    }
                    if (typeof toggle[key] !== allowedProperty.type) {
                        throw new Error(`${methodName}: toggle override property "${key}" should be of type ${allowedProperty.type}`);
                    }
                });
                // check that all required values are present
                requiredToggleValues.forEach(({ name, type }) => {
                    if (typeof toggle[name] !== type) {
                        throw new Error(`${methodName}: toggle override property "${name}" should be of type ${type}`);
                    }
                });
                this.store.dispatch(new OverrideGlobalToggle(toggle));
            };
        }
    }
};
TemporaryWindowOverrideTogglesService.ɵfac = function TemporaryWindowOverrideTogglesService_Factory(t) { return new (t || TemporaryWindowOverrideTogglesService)(ɵngcc0.ɵɵinject(ɵngcc1.Store)); };
TemporaryWindowOverrideTogglesService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: TemporaryWindowOverrideTogglesService, factory: function (t) { return TemporaryWindowOverrideTogglesService.ɵfac(t); } });
TemporaryWindowOverrideTogglesService.ctorParameters = () => [
    { type: Store }
];

let GlobalTogglesService = class GlobalTogglesService {
    constructor(http, windowOverride, // sigh, we need to include this service somewhere so it gets instantiated
    config$) {
        this.http = http;
        this.windowOverride = windowOverride;
        this.config$ = config$;
        // store fetch results to prevent duplicate fetching
        this._cache$ = {};
        // really what we care about from config$ is the hostname
        this.hostname$ = this.config$.pipe(filter((config) => !!(config && (config.hostNames || config.sdlcEnvironment))), map((config) => hostnamesFromConfig(config).scoutProxy));
    }
    getTogglesByOwner(owner) {
        if (!this._cache$[owner]) {
            this._cache$[owner] = this.fetchTogglesByOwner(owner).pipe(shareReplay(1));
        }
        return this._cache$[owner];
    }
    fetchTogglesByOwner(owner) {
        return this.hostname$.pipe(take(1), switchMap((hostname) => {
            const url = `https://${hostname}/public/v2/toggles/${owner}`;
            return this.http.get(url).pipe(retry(3));
        }));
    }
    fetchAllToggles() {
        return this.hostname$.pipe(take(1), switchMap((hostname) => {
            const url = `https://${hostname}/public/v2/toggles`;
            return this.http.get(url).pipe(retry(3));
        }));
    }
};
GlobalTogglesService.ɵfac = function GlobalTogglesService_Factory(t) { return new (t || GlobalTogglesService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(TemporaryWindowOverrideTogglesService), ɵngcc0.ɵɵinject(GLOBAL_TOGGLE_CONFIG)); };
GlobalTogglesService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GlobalTogglesService, factory: function (t) { return GlobalTogglesService.ɵfac(t); } });
GlobalTogglesService.ctorParameters = () => [
    { type: HttpClient },
    { type: TemporaryWindowOverrideTogglesService },
    { type: Observable, decorators: [{ type: Inject, args: [GLOBAL_TOGGLE_CONFIG,] }] }
];
GlobalTogglesService = __decorate([ __param(2, Inject(GLOBAL_TOGGLE_CONFIG))
], GlobalTogglesService);

let GlobalTogglesEffects = class GlobalTogglesEffects {
    constructor(actions$, store, globalTogglesService) {
        this.actions$ = actions$;
        this.store = store;
        this.globalTogglesService = globalTogglesService;
        this.toggleGet$ = this.actions$.pipe(ofType(GlobalToggleActions.GetGlobalToggleAction), withLatestFrom(this.store.select(getAllGlobalToggles), ({ payload }, store) => {
            return {
                identifier: payload,
                value: store.toggles[payload.owner] &&
                    store.toggles[payload.owner][payload.name] &&
                    store.toggles[payload.owner][payload.name].value,
            };
        }), map((result) => {
            // If the toggle is in the store, we are done, else, try to go find it
            return result.value !== undefined
                ? new GlobalToggleCacheHit(result.identifier)
                : new GlobalToggleCacheMiss(result.identifier);
        }));
        this.toggleGetAll$ = this.actions$.pipe(ofType(GlobalToggleActions.GetAllGlobalTogglesAction), switchMap(() => this.globalTogglesService.fetchAllToggles()), catchError((httpError) => of(httpError)), map((response) => {
            if (response instanceof HttpErrorResponse) {
                return new GetAllGlobalTogglesError(response);
            }
            else {
                return new BulkUpsertGlobalToggleCache(response);
            }
        }));
        this.toggleFind$ = this.actions$.pipe(ofType(GlobalToggleActions.GlobalToggleCacheMiss), mergeMap(({ payload }) => {
            // see if the toggleService knows about the toggle in question
            return this.globalTogglesService.getTogglesByOwner(payload.owner).pipe(catchError((httpError) => of(httpError)), map((response) => {
                if (response instanceof HttpErrorResponse) {
                    return { value: null, identifier: payload, error: response };
                }
                const toggle = response.find((t) => t.name === payload.name);
                return { value: toggle, identifier: payload, error: null };
            }));
        }), map(({ value, identifier, error }) => {
            if (value || error) {
                // put the requested into the store
                return new UpsertGlobalToggleCache({
                    identifier,
                    value: { value, isOverridden: false, error },
                });
            }
            else {
                return new GlobalToggleUnknown(identifier);
            }
        }));
        this.toggleUnknown$ = this.actions$.pipe(ofType(GlobalToggleActions.GlobalToggleUnknown), map(({ payload }) => {
            return new UpsertGlobalToggleCache({
                identifier: payload,
                value: { value: null, isOverridden: false, error: null },
            });
        }));
    }
};
GlobalTogglesEffects.ɵfac = function GlobalTogglesEffects_Factory(t) { return new (t || GlobalTogglesEffects)(ɵngcc0.ɵɵinject(ɵngcc4.Actions), ɵngcc0.ɵɵinject(ɵngcc1.Store), ɵngcc0.ɵɵinject(GlobalTogglesService)); };
GlobalTogglesEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GlobalTogglesEffects, factory: function (t) { return GlobalTogglesEffects.ɵfac(t); } });
GlobalTogglesEffects.ctorParameters = () => [
    { type: Actions },
    { type: Store },
    { type: GlobalTogglesService }
];
__decorate([
    Effect()
], GlobalTogglesEffects.prototype, "toggleGet$", void 0);
__decorate([
    Effect()
], GlobalTogglesEffects.prototype, "toggleGetAll$", void 0);
__decorate([
    Effect()
], GlobalTogglesEffects.prototype, "toggleFind$", void 0);
__decorate([
    Effect()
], GlobalTogglesEffects.prototype, "toggleUnknown$", void 0);

var GlobalTogglesModule_1;
/**
 * @platformUseOnly
 * @description
 * Including this module in an app will provide an API for a
 * platform (and its modules) to fetch global (SCOUT) toggles
 * and access them from the store.
 * @usageNotes
 * This module adds a feature slice to the ngrx-store, so
 * your app must provide the ngrx-store and ngrx-effects.
 *
 * This modules requires configuration be passed in via
 * by providing a factory function into `withConfig`.
 */
let GlobalTogglesModule = GlobalTogglesModule_1 = class GlobalTogglesModule {
    /**
     * @platformUseOnly
     * @description
     * Provides a way for a platform to pass in configuration
     * data from any DI service.
     * @usageNotes
     * This method requires a factory function argument.
     * REMINDER: The AoT compiler does not interpret all TS.
     * "Factory functions must be exported, named functions. The AOT
     * compiler does not support lambda expressions ("arrow functions")
     * for factory functions."
     * [Angular Docs](https://angular.io/guide/aot-compiler#supported-classes-and-functions)
     *
     * @example
     * export function configFactory(store: Store): Observable<Config> {
     *  return of({sdlcEnvironment: 'dev'});
     * }
     *
     * export const configuredModule = GlobalTogglesModule.withConfig({
     *  useFactory: configFactory,
     *  deps: [Store]
     * });
     */
    static withConfig(configFactoryOptions) {
        return {
            ngModule: GlobalTogglesModule_1,
            providers: [
                {
                    provide: GLOBAL_TOGGLE_CONFIG,
                    useFactory: configFactoryOptions.useFactory,
                    deps: configFactoryOptions.deps,
                },
                GlobalTogglesService,
                TemporaryWindowOverrideTogglesService,
            ],
        };
    }
};
GlobalTogglesModule.ɵfac = function GlobalTogglesModule_Factory(t) { return new (t || GlobalTogglesModule)(); };
GlobalTogglesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: GlobalTogglesModule });
GlobalTogglesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [StoreModule.forFeature(sliceName, toggleReducer),
        EffectsModule.forFeature([GlobalTogglesEffects])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TemporaryWindowOverrideTogglesService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.Store }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GlobalTogglesService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: TemporaryWindowOverrideTogglesService }, { type: ɵngcc3.Observable, decorators: [{
                type: Inject,
                args: [GLOBAL_TOGGLE_CONFIG]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GlobalTogglesEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.Actions }, { type: ɵngcc1.Store }, { type: GlobalTogglesService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GlobalTogglesModule, [{
        type: NgModule,
        args: [{
                imports: [
                    StoreModule.forFeature(sliceName, toggleReducer),
                    EffectsModule.forFeature([GlobalTogglesEffects]),
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(GlobalTogglesModule, { imports: [ɵngcc1.StoreFeatureModule, ɵngcc4.EffectsFeatureModule] }); })();

// stuff to use the feature slice

/**
 * Generated bundle index. Do not edit.
 */

export { GetAllGlobalTogglesAction, GetGlobalToggleAction, GlobalTogglesModule, getAllGlobalTogglesLoaded, getGlobalToggleSelector, GLOBAL_TOGGLE_CONFIG as ɵa, getAllGlobalToggles as ɵb, sliceName as ɵd, toggleReducer as ɵe, GlobalTogglesEffects as ɵf, GlobalTogglesService as ɵg, TemporaryWindowOverrideTogglesService as ɵh };

